import './access-level-preset-picker.scss'
import {AccessLevelConfig} from "../../model/AccessLevelConfig";
import {AccessLevelPreset} from "../../model/AccessLevelPreset";
import {UserAccessLevelPresetServiceName} from "../../../utils/names/serviceNames";
import {UserAccessLevelPresetService} from "../../../users_service/service/user-access-level-preset.service";
import {UserDto} from "../../model/User";

const DEFAULT_PRESET_NAME = 'Loan Officer';

export class AccessLevelPresetPicker {

    static instance = {
        template: require('./access-level-preset-picker.html'),
        controller: [
            UserAccessLevelPresetServiceName,
            AccessLevelPresetPicker
        ],
        bindings: {
            accessLevelConfig: '<',
            user: '='
        }
    }

    private accessLevelPresets: AccessLevelPreset[]
    private accessLevelConfig: AccessLevelConfig;
    private selectedAccessLevelPreset: AccessLevelPreset;
    private user: UserDto;

    constructor(private userAccessLevelPresetService: UserAccessLevelPresetService) {
    }

    $onInit() {
        this.userAccessLevelPresetService.fetchAllPresets()
            .then(presets => {
                this.accessLevelPresets = presets;
                let initialPresetName = this.getInitialPresetNme();
                this.selectedAccessLevelPreset = this.accessLevelPresets.find(preset => preset.name === initialPresetName)
                if (this.accessLevelConfig.isNewUser) {
                    this.onAccessLevelPresetChange(this.selectedAccessLevelPreset);
                }
            })
    }

    private getInitialPresetNme(): string {
        if (this.accessLevelConfig.isNewUser) {
            return DEFAULT_PRESET_NAME;
        } else {
            return this.user.userType;
        }
    }

    public onAccessLevelPresetChange = (preset: AccessLevelPreset) => {
        this.updateUserAccessLevelToggles(preset);
        this.user.userType = preset.name;
    }

    private updateUserAccessLevelToggles(preset: AccessLevelPreset) {
        this.user.featureAccessLevel.forEach(accessLevel => {
            accessLevel.status = preset.accessLevels[accessLevel.authorityName];
        });
    }
}